import { Component, ElementRef, ViewChild } from '@angular/core';
import { App, NavController, NavParams } from 'ionic-angular';
import { GoogleMapsComponent } from '../../../../components/google-maps/google-maps';
import { IconPipe } from '../../../../pipes/icon/icon';
import { EventListModel } from '../../../../providers/event/event';
import { GoogleMapsProvider } from '../../../../providers/google-maps/google-maps';
import { EventTabsPage } from '../../details/event-tabs/event-tabs';
import { EventListPage } from '../../event-list/event-list';


/**
 * Generated class for the EventSearchMapPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-event-search-map',
  templateUrl: 'event-search-map.html',
})
export class EventSearchMapPage {

  @ViewChild('map') mapElement: ElementRef;
  marker: any;
  @ViewChild(GoogleMapsComponent)
  maps: GoogleMapsComponent;

  events: EventListModel[];
  constructor(public navCtrl: NavController, public navParams: NavParams, private iconPipe: IconPipe, private app: App, private googleMaps: GoogleMapsProvider) {
    console.log("event-search-map.ts constructor()");
    this.events = navParams.data.events.filter(x => x.lat !== null && x.lng !== null);
  }

  ngAfterContentInit() {

  }

  mapLoaded(map) {
    this.googleMaps.getGoogle().then(async (google) => {
      var me = this;
      let markers = [];
      var bounds = new google.maps.LatLngBounds();

      for (let index = 0; index < this.events.length; index++) {
        let icon = await this.iconPipe.transform(this.events[index].cid + "", "marker");
        let marker = new google.maps.Marker({
          position: this.events[index],
          icon: icon
        });
        marker.addListener('click', function () {
          console.log(marker.containedModel);
          (me.app.getRootNav() as NavController).push(EventTabsPage, { event: marker.containedModel });
        });
        marker.containedModel = this.events[index];
        markers.push(marker);
        bounds.extend(marker.getPosition());
      }




      map.fitBounds(bounds);

      // @ts-ignore
      var markerCluster = new MarkerClusterer(map, markers,
        {
          zoomOnClick: false,
          imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'
        });
      google.maps.event.addListener(markerCluster, 'clusterclick', async function (cluster) {
        let containedEvents = [];
        await cluster.getMarkers().forEach(marker => {
          containedEvents.push(marker.containedModel);
          console.log(marker.containedModel);
        });
        (me.app.getRootNav() as NavController).push(EventListPage, { events: containedEvents });
      });
    });


  }

}



// WEBPACK FOOTER //
// /src/pages/event/main/event-search-map/event-search-map.ts